/**
 * User Model — UX ONLY
 * Role helpers (isAdmin/isOperator) are for UI routing only, never for security.
 * Backend authorization is authoritative; frontend must not enforce access control.
 */
export class User {
    constructor(data = {}) {
        this.id = data.id || null;
        this.phoneNumber = data.phoneNumber || '';
        this.firstName = data.firstName || '';
        this.lastName = data.lastName || '';
        this.nationalCode = data.nationalCode || '';
        this.birthDate = data.birthDate || '';
        this.email = data.email || '';
        this.avatar = data.avatar || '';
        this.isKyced = data.isKyced || false;
        this.username = data.username || '';
        this.role = data.role || 'user'; // 'user', 'admin', or 'operator'
        this.isActive = data.isActive !== undefined ? data.isActive : true;
        this.createdAt = data.createdAt || null;
        this.updatedAt = data.updatedAt || null;
    }

    getFullName() {
        const fullName = `${this.firstName} ${this.lastName}`.trim();
        if (fullName) {
            return fullName;
        }
        // For admin/operator, fall back to username if name not available
        if (this.role !== 'user' && this.username) {
            return this.username;
        }
        return 'کاربر';
    }

    hasCompletedProfile() {
        // Admin/operator don't need profile completion
        if (this.role !== 'user') {
            return true;
        }
        return !!(this.firstName && this.lastName && this.nationalCode && this.birthDate);
    }

    isAdmin() {
        return this.role === 'admin';
    }

    isOperator() {
        return this.role === 'operator';
    }

    isRegularUser() {
        return this.role === 'user';
    }

    isLevel1() {
        return !this.isKyced;
    }

    isLevel2() {
        return this.isKyced;
    }

    canIssueCertificate() {
        return this.isKyced;
    }

    canSignPDF() {
        return this.isKyced;
    }

    toJSON() {
        return {
            id: this.id,
            phoneNumber: this.phoneNumber,
            firstName: this.firstName,
            lastName: this.lastName,
            nationalCode: this.nationalCode,
            birthDate: this.birthDate,
            email: this.email,
            avatar: this.avatar,
            isKyced: this.isKyced,
            username: this.username,
            role: this.role,
            isActive: this.isActive,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        };
    }
}

export default User;
